.loadMore {
  display: block;
  font-family: var(--ogm-font-family-1);
  font-size: 14px;
  text-align: center;
  padding: 10px;
  color: #fff;
  text-transform: uppercase;
  margin: 0 auto;
  width: 100%;
  border: solid 2px var(--ogm-mavericks);
  box-sizing: border-box;
  cursor: pointer;
}

@keyframes tickAnimation {
  0% {
    opacity: 0.9;
  }
  20% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  70% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
  }
}
.returns {
  display: block;
  font-size: 13px;
  width: 80px;
  padding: 5px 0;
}

.sectionWrapper {
  display: flex;
  flex-direction: column;
  height: 60px;
}
.sectionWrapper .stakeTitle {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
}
.sectionWrapper .input {
  width: 45px;
  height: 30px;
  border-radius: 3px;
  border: solid 1px var(--ogm-pelicans);
  padding: 5px;
}
.sectionWrapper .returnsTitle {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
}
.sectionWrapper .returns {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  height: 30px;
}

@media (max-width: 320px) {
  .sectionWrapper {
    display: flex;
    flex-direction: column;
    height: 40px;
    max-width: 45px;
  }
  .sectionWrapper .stakeTitle {
    font-family: var(--ogm-font-family-2);
    font-weight: 400;
    font-size: 12px;
    line-height: 1.2em;
    text-transform: none;
  }
  .sectionWrapper .input {
    width: 30px;
    height: 20px;
    border-radius: 3px;
    border: solid 1px var(--ogm-pelicans);
    padding: 5px;
  }
  .sectionWrapper .returnsTitle {
    font-family: var(--ogm-font-family-2);
    font-weight: 400;
    font-size: 12px;
    line-height: 1.2em;
    text-transform: none;
  }
  .sectionWrapper .returns {
    font-family: var(--ogm-font-family-2);
    font-weight: 700;
    font-size: 14px;
    line-height: 1.2em;
    text-transform: none;
    height: 30px;
  }
}
